

<template>
  <div
    @click="$emit('select')"
    :class="[
      'w-full bg-[#18181b] rounded-xl border-2 mb-4 flex items-stretch cursor-pointer transition-all duration-200',
      selected ? 'border-[#CB34C5] shadow-[0_0_0_2px_#CB34C5]' : 'border-[#232326]'
    ]"
  >
    <!-- Left: Price Block -->
    <div class="flex flex-col justify-center items-start px-4 md:px-6 py-3 md:py-4 flex-1">
          <span v-if="selected" class="inline-block align-middle mr-2">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="11" stroke="#CB34C5" stroke-width="2"/><path d="M8 12.5L11 15.5L16 10.5" stroke="#CB34C5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </span>
      <span class="text-right text-gray-300 text-sm md:text-base mb-2">ابتداء من</span>
      <span class="text-2xl md:text-3xl font-bold text-white mb-1">{{ price.toLocaleString() }}</span>
      <span class="text-sm md:text-base text-gray-400">جنيه/{{ periodLabel }}</span>
    </div>
  <!-- Right: Title, Details, Operators -->
  <div class="flex flex-col justify-center items-end px-4 md:px-6 py-3 md:py-4 w-8/12 text-right ">
      <div class="flex items-center gap-2 mb-2 justify-end">
                <span v-if="popular" class="bg-[#CB34C5] text-white rounded px-2 md:px-3 py-1 text-xs font-semibold">الأكثر شهرة</span>

        <span class="text-md md:text-2xl font-bold text-white">{{ title }}</span>
      
      </div>
      <div class="text-gray-400 text-xs md:text-base mb-2">يمكنك الدفع باستخدام</div>
      <div class="flex items-center gap-2 md:gap-3 justify-end">
        <span v-for="op in operators" :key="op" class="inline-block">
          <img :src="getOperatorLogo(op)" :alt="op" class="w-8 md:w-10 h-8 md:h-10 object-contain" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlanCard',
  props: {
    price: Number,
    period: String,
    title: String,
    operators: Array,
    selected: Boolean,
    popular: Boolean
  },
  computed: {
    periodLabel() {
      switch (this.period) {
        case 'day': return 'اليوم';
        case 'week': return 'الأسبوع';
        case 'month': return 'الشهر';
        case 'year': return 'السنة';
        default: return this.period;
      }
    }
  },
  methods: {
    getOperatorLogo(op) {
      // Map operator to logo path
      const logos = {
        sudani: require('@/assets/tele/sudani-new.png'),
        mtn: require('@/assets/tele/mtn-logo.png'),
        zain: require('@/assets/tele/zain.png'),
        bravo: require('@/assets/tele/bravo.png'),
      };
      return logos[op] || '';
    }
  }
}
</script>


<!-- All styles are now handled by Tailwind CSS classes in the template -->
